// src/i18n/ar/views/iframes.js
export const iframes = {
  pricing: {
    title: "حاسبة الأسعار",
    description:
      "اضبط الأسعار الأساسية والإضافات لكل وحدة في كل خطة؛ تُظهر الفواتير الضريبة كبند منفصل.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "فيديو: حاسبة الأسعار (AR)",
  },
  connectBooking: {
    title: "ربط Booking.com",
    description:
      "دليل خطوة بخطوة لربط عقارك بـ Booking.com عبر مدير القنوات.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "فيديو: ربط Booking.com (AR)",
  },
  connectAirbnb: {
    title: "ربط Airbnb (عبر Channex)",
    description:
      "فعِّل اتصال Airbnb من نظام إدارة العقارات لديك باستخدام Channex وزامِن الإتاحة والأسعار.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "فيديو: ربط Airbnb (AR)",
  },
  channexCertification: {
    title: "اعتماد Channex · نظام إدارة العقارات",
    description:
      "المتطلبات والاختبارات لإكمال اعتماد نظام إدارة العقارات مع Channex (المزامنة الكاملة والأسعار والقيود).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "فيديو: اعتماد Channex (AR)",
  },
  hotelCalendar: {
    title: "تقويم الفندق (متعدد الغرف)",
    description:
      "أدِر الحجوزات حسب نوع الغرفة والوحدة؛ تجنّب الحجوزات الزائدة بعرض منظّم.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "فيديو: تقويم الفندق (AR)",
  },
  apartmentCalendar: {
    title: "تقويم الشقق",
    description:
      "الحجب وأسعار الأيام والإقامات في تقويم لكل عقار.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "فيديو: تقويم الشقق (AR)",
  },
  guestCheckin: {
    title: "تسجيل الوصول عبر WhatsApp",
    description:
      "يمسح النزلاء بطاقة هويتهم، ويجتازون التحقق من الهوية، ويوقّعون رقميًا من هواتفهم.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "فيديو: تسجيل الوصول عبر WhatsApp (AR)",
  },
  identityVerification: {
    title: "التحقق من الهوية والتوقيع الإلكتروني",
    description:
      "التحقق بالصورة الذاتية، وقراءة MRZ/PDF417، وتوقيع إلكتروني آمن للامتثال.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "فيديو: التحقق من الهوية (AR)",
  },
  smartLocks: {
    title: "الأقفال الذكية",
    description:
      "أرسِل رموز دخول تلقائية — دون مفاتيح أو انتظار. يدعم الرموز الديناميكية.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "فيديو: الأقفال الذكية (AR)",
  },
  reviewsAutomation: {
    title: "أتمتة التقييمات",
    description:
      "جدوِل تذكيرات التقييم ونمِّ سمعة عقارك.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "فيديو: أتمتة التقييمات (AR)",
  },
};
